import React, { Component } from "react"
import MediumSpacer from "../../components/MediumSpacer"
import HistoryPreviewBox from "../../components/HistoryPreviewBox"
import { ApiConfig, API_URL } from "./../../settings"
import LoadingBox from "./../../components/LoadingBox"
import { updateCanonicalLink } from "../../helpers/helpers"
import axios from "axios";
 
export default class Articles extends Component {  
    constructor(props) {
        super(props)

        this.perPage = 15
        this.state = {
            articles: [],
            totalPages: null,
            page: 1, 
            error: false,
            loading: true
        }
    }
    componentDidMount() {
        this.getArticles(1)
        updateCanonicalLink();
    }
    async getArticles(page = 1) {
        try {
            this.setState({ loading: true });

            axios
                .get(`${API_URL}/api/articles?limit=${this.perPage}&skip=${this.perPage * (page - 1)}`, ApiConfig)
                .then((response) => {
                    console.log(response.data.total);
                    this.setState({
                        page,
                        articles: response.data.data,
                        error: false,
                        totalPages: Math.ceil(response.data.total / this.perPage)
                    });
                })
                .catch((error) => {
                    console.error("Error", error);
                    this.setState({ error: true });
                });
        } finally {
            this.setState({ loading: false });
        }
    }
    render() {
        if (this.state.error) {
            return <div className="container"><MediumSpacer /><p>Det oppstod en feil. Prøv å laste siden på nytt.</p><MediumSpacer /></div>
        }

        if (this.state.loading) {
            return <div><MediumSpacer /><LoadingBox text="Laster artikler..." /><MediumSpacer /></div>
        }

        return ( 
            <div className="container">
                <MediumSpacer />
                <h1 className="page-title">Artikler</h1>

                <div className="grid-column-3">
                    {this.state.articles.map(data => {
                        const imageUrl = data.fields.images[0] ? data.fields.images[0].fields.file.url  : "https://placehold.co/600x400";
         
                        return ( 
                            <HistoryPreviewBox
                                key={data.sys.id}
                                title={data.fields.title}
                                link={`/artikler/${data.sys.id}`}
                                description={data.fields.body}
                                image={imageUrl} /> 
                        )
                    })}
                </div>
                
                <MediumSpacer />
                
                {
                    this.state.totalPages > 1 ? ( 
                        <div className="pagination">
                            <button className="button button--purple button--large" disabled={this.state.page <= 1} onClick={() => this.getArticles(this.state.page - 1)}>Forrige side</button>
                            <p>Side {this.state.page} av {this.state.totalPages}</p>
                            <button className="button button--purple button--large"  disabled={this.state.totalPages === this.state.page} onClick={() => this.getArticles(this.state.page + 1)}>Neste side</button>
                        </div>
                    ) : null
                }

                <MediumSpacer />
            </div> 
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/Articles/index.js